import { Skeleton } from 'modules/Skeleton';
import { pxToRem } from 'modules/spacing';
import { useLoad } from '../Table/hooks/useLoad';
import { TableBodyCell } from '../TableCell';
import { TableRow } from '../TableRow';
import { StyledTableBody } from './styled';
export function TableBody(props) {
    const { children } = props;
    const { loading, initialLoading, loadingRows, loadingColumns } = useLoad();
    const subsequentLoading = loading && !initialLoading;
    const getSkeletonWidth = () => `${Math.floor(Math.random() * (80 - 60) + 60)}%`;
    if (initialLoading) {
        return (<StyledTableBody>
        {Array.from(Array(loadingRows).keys()).map((row) => (<TableRow key={row} disabled>
            {Array.from(Array(loadingColumns).keys()).map((cell) => (<TableBodyCell key={cell} headers="" loading>
                <Skeleton loading width={getSkeletonWidth()} height={pxToRem(16)}/>
              </TableBodyCell>))}
          </TableRow>))}
      </StyledTableBody>);
    }
    return <StyledTableBody $subsequentLoading={subsequentLoading}>{children}</StyledTableBody>;
}
